import {
    AfterViewChecked,
    AfterViewInit,
    Component,
    HostListener,
    Inject
} from '@angular/core';
import {DOCUMENT} from "@angular/common";
import {UIRouterGlobals} from "@uirouter/angular";
import {SettingsService} from "../core";

@Component({
    selector: 'app-abstract',
    templateUrl: './abstract.component.html',
    styleUrls: ['./abstract.component.scss']
})
export class AbstractComponent implements AfterViewInit, AfterViewChecked {
    private mainView: Element | null = null;
    private currentState: string = '';
    private scrollTop: number = 0;

    constructor(
        private uiRouterGlobals: UIRouterGlobals,
        @Inject(DOCUMENT) private document: Document,
        private settings: SettingsService,
    ) {
    }

    ngAfterViewInit() {
        if (this.mainView === null) {
            this.mainView = this.document.querySelector('.main-view');
        }
        this.currentState = this.uiRouterGlobals.current.name;
    }

    ngAfterViewChecked() {
        if (this.uiRouterGlobals.current.name !== this.currentState) {
            this.currentState = this.uiRouterGlobals.current.name;

            // keep scroll position for settings subpages
            if (!this.currentState.includes('settings.')) {
                this.scrollTop = 0;
            }
        }
        if (this.scrollTop !== this.mainView.scrollTop) {
            this.mainView.scrollTop = this.scrollTop;
        }
    }

    handleClickOutside(): void {
        if (this.currentState === 'settings.module_info') {
            this.settings.clickOutsideToClose.next(false);
        }
    }

    @HostListener('window:scroll', ['$event'])
    onScroll(event: any): void {
        this.scrollTop = event.target.scrollTop;
    }
}

